import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function EmptyState({
  icon = "ri-search-eye-line",
  title,
  description,
  actionLabel = "返回首页",
  actionTo = "/",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-700 bg-background-900/60 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-900/70 text-accent-500">
        <i className={`${icon} text-2xl`} />
      </span>
      <h3 className="mt-5 font-heading text-base font-semibold text-foreground-100">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-6 text-foreground-400">{description}</p>
      <Link
        to={actionTo}
        className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-background-950 transition-colors hover:bg-accent-400"
      >
        <i className="ri-arrow-left-line text-base" />
        {actionLabel}
      </Link>
    </div>
  );
}